import { z } from "zod";
import { emailValidator } from "../../../lib/validator/email";

export const ResetPasswordFormSchema = z.object({
  email: emailValidator,
});

export type ResetPasswordFormSchemaType = z.infer<
  typeof ResetPasswordFormSchema
>;
